var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#8F806C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 15.0625C18.125 15.5266 17.9405 15.9716 17.6123 16.2998C17.2841 16.628 16.8391 16.8125 16.375 16.8125H7.625C7.16087 16.8125 6.71588 16.628 6.3877 16.2998C6.05954 15.9716 5.875 15.5266 5.875 15.0625V10.0576L11.083 13.2617C11.3588 13.4314 11.6762 13.5215 12 13.5215C12.3238 13.5215 12.6412 13.4314 12.917 13.2617L18.125 10.0576V15.0625ZM16.375 7.1875C16.8391 7.1875 17.2841 7.37201 17.6123 7.7002C17.9405 8.02838 18.125 8.47337 18.125 8.9375V9.0293L12.459 12.5166C12.3211 12.6014 12.1619 12.6465 12 12.6465C11.8381 12.6465 11.6789 12.6014 11.541 12.5166L5.875 9.0293V8.9375C5.875 8.47337 6.05951 8.02838 6.3877 7.7002C6.71588 7.37201 7.16087 7.1875 7.625 7.1875H16.375Z",
    fill: "#8F806C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBox);
export default __webpack_public_path__ + "static/media/emailBox.2adb68aaeecf966eac78bc7c6e9a311b.svg";
export { ForwardRef as ReactComponent };